<mat-toolbar [color]="'accent'" cdkDragHandle class="m-0"
             fxLayout="row" fxLayoutAlign="space-between center">
        <h2 mat-dialog-title class="title dialog-title m-0 p-0" [innerText]="pageTitle"></h2>
        <button data-test="B-Close-dialog" mat-icon-button
                (click)="onClickLeaveButton()"
                [attr.aria-label]="'common.closeDialogAria' | translate" type="button">
            <mat-icon>close</mat-icon>
        </button>
    </mat-toolbar>
